import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, RefreshCw, Trophy } from "lucide-react";
import { API, axios, authHeaders, apiErr } from "@/lib/api";

const medal = (i) => (i === 0 ? "text-[#ccff00]" : i === 1 ? "text-zinc-300" : i === 2 ? "text-[#ff0055]" : "text-zinc-600");

const AdminReferrals = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await axios.get(`${API}/admin/referrals/leaderboard`, authHeaders());
      setRows(data);
    } catch (e) { toast.error(apiErr(e)); setError(true); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  if (loading) return <div className="py-20 text-center text-zinc-500"><Loader2 className="animate-spin inline" /></div>;

  return (
    <div data-testid="admin-referrals-panel">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-display font-black text-3xl">Referrals <span className="text-zinc-600 text-xl">({rows.length})</span></h1>
        <button onClick={load} className="inline-flex items-center gap-2 rounded-full border border-white/20 text-white text-xs font-bold uppercase tracking-widest px-5 py-2.5 hover:bg-white/5 transition-colors" data-testid="referrals-refresh"><RefreshCw size={14} /> Refresh</button>
      </div>

      <div className="space-y-2">
        {rows.map((r, i) => (
          <div key={r.order_id} className={`flex items-center gap-4 bg-[#121212] border rounded-xl p-4 ${r.times_redeemed > 0 ? "border-[#ccff00]/30" : "border-white/10"}`} data-testid={`referral-row-${r.order_id}`}>
            <Trophy size={18} className={medal(i)} />
            <span className="text-zinc-500 w-6 text-sm">#{i + 1}</span>
            <div className="flex-1 min-w-0">
              <p className="font-medium truncate">{r.business}</p>
              <p className="text-xs text-zinc-500 font-mono">{r.referral_code}</p>
            </div>
            <div className="text-right" data-testid={`referral-count-${r.order_id}`}>
              <p className="font-display font-black text-xl">{r.times_redeemed}</p>
              <p className="text-xs text-zinc-500 uppercase tracking-widest">{r.times_redeemed === 1 ? "referral" : "referrals"}</p>
            </div>
          </div>
        ))}
        {rows.length === 0 && !error && <p className="text-zinc-500 py-16 text-center">No referral codes issued yet. They're sent automatically once an order is marked Delivered.</p>}
        {error && <p className="text-[#ff0055] py-16 text-center" data-testid="referrals-error">Couldn't load referrals — try refreshing.</p>}
      </div>
    </div>
  );
};

export default AdminReferrals;
